const RemoveLastDirectoryPartOf = (the_url) => {
    var the_arr = the_url.split('/');
    the_arr.pop();
    return the_arr.join('/');
};

export default RemoveLastDirectoryPartOf;
